import { useState } from "react";
import { Route, Router, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import ProjectDetails from "./components/Home/ProjectDetails";
import Home from "./components/Home/Home";
import SideBar from "./components/SideBar/SideBar";

function App() {
  const location = useLocation();
  const [mode, setMode] = useState(false);
  const pathName = location.pathname;
  const detailsLocation = pathName.split("/")[1];
  const themes = (event) => setMode(event.target.checked);
  return (
    <div
      style={{ fontFamily: "'Roboto', sans-serif" }}
      className={`App min-h-screen  ${
        mode ? "text-[#2c3641] bg-white " : "bg-[#2c3641] text-white "
      }`}
    >
      {!detailsLocation && <Header />}
      <SideBar themes={themes} mode={mode} />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/details/:id" element={<ProjectDetails />} />
      </Routes>
      {!detailsLocation && <Footer />}

      <ToastContainer />
    </div>
  );
}

export default App;
